import { isValid, parse } from 'date-fns';

import { EMAIL_REGEXP, PHONE_REGEXP } from '../../../constants/regex';

export function isValidString(key: string, value: unknown, mandatory = false): true {
  if (typeof value === 'string' || (!mandatory && value === null)) {
    return true;
  }

  throw new Error(`Invalid ${key}`);
}

export function isValidNumber(key: string, value: unknown, mandatory = false): true {
  if (
    typeof value === 'number' ||
    (typeof value === 'string' && !Number.isNaN(Number(value))) ||
    (!mandatory && value === null)
  ) {
    if (Number(value) >= 0) {
      return true;
    }
  }

  throw new Error(`Invalid ${key}`);
}

export function isValidBoolean(key: string, value: unknown): true {
  if (typeof value === 'boolean' || value === 'true' || value === 'false') {
    return true;
  }

  throw new Error(`Invalid ${key}`);
}

export function isValidEnum(key: string, value: unknown, enumObj: Record<string, string>): true {
  if ((typeof value === 'string' && value in enumObj) || value === null) {
    return true;
  }

  throw new Error(`Invalid ${key}`);
}

export function isValidArrayField<T>(key: string, value: unknown, callback: (item: T) => true): true {
  if (Array.isArray(value)) {
    return value.every(callback) as true;
  }

  throw new Error(`Invalid ${key}`);
}

export function isValidDate(key: string, value: unknown, mandatory = false): true {
  if (
    (typeof value === 'string' && isValid(parse(value, 'yyyy-MM-dd', new Date()))) ||
    (!mandatory && value === null)
  ) {
    return true;
  }

  throw new Error(`Invalid ${key}`);
}

export function isValidEmail(key: string, value: unknown): true {
  if ((typeof value === 'string' && EMAIL_REGEXP.test(value)) || value === null) {
    return true;
  }

  throw new Error(`Invalid ${key}`);
}

export function isValidPhoneNumber(key: string, value: unknown): true {
  if ((typeof value === 'string' && PHONE_REGEXP.test(value)) || value === null) {
    return true;
  }

  throw new Error(`Invalid ${key}`);
}
